import { isArray } from 'util';
import { Subactivity } from '../subactivity';
import { ActivityBuilder } from './activity.builder';
import { parseNumber } from '../../utils/number.utils';

export class SubactivityBuilder {
  static fromJson(json) {
    return (json)
      ? new Subactivity(
        json.hash,
        json.name,
        ActivityBuilder.fromJson(json.activity),
        json.manual,
        parseNumber(json.time)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(SubactivityBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/subactivity.builder.ts